import { restoreUserImpersonatorInLocalStorage } from '../helpers/local-storage';

export default () => {
  restoreUserImpersonatorInLocalStorage();
  window.location.href = '/';
};
